import React, { useEffect, useRef } from "react";

//material ui
import { useTheme } from "@mui/styles";
import { Box, Typography, useMediaQuery } from "@mui/material";

//img
import HomeBlueBackground from "../../img/HomeBlueBackground.png";

//json2mq
import json2mq from "json2mq";

const useStyles = (theme, width, mobileHeight) => ({
  box: {
    height: { xs: mobileHeight ? mobileHeight :"425px", md: "450px", lg: "500px", xl: "575px" },
    width: "100%",
    backgroundImage: {
      xs: `url(${HomeBlueBackground})`,
    },
    borderRadius: { xs: "0 0 40px 40px", md: "0px 0px 116px 116px" },
    backgroundRepeat: "no-repeat",
    backgroundSize: { xs: "cover", md: "100% 100%" },
    display: "flex",
    alignItems: { xs: "center", md: "flex-start" },
    flexDirection: { xs: "column", md: "row" },
    justifyContent: { md: "center" },
    color: theme.palette.white.main,
  },
  title: {
    maxWidth: { xs: "277px", md: "400px", lg: "500px", xl: "597px" },
    textAlign: { xs: "center", md: "inherit" },
    fontFamily: theme.typography.montserrat.bold,
    fontSize: { xs: "35px", md: "45px", lg: "55px", xl: "70px" },
    lineHeight: { xs: "43px", md: "inherit" },
    mt: { xs: "80px", md: "75px", lg: "85px", xl: "100px" },
  },

  subtitle: {
    width: width ? width : { xs: "287px", md: "365px" },
    textAlign: { xs: "center", md: "start" },
    fontFamily: theme.typography.montserrat.regular,
    fontSize: { xs: "16px", md: "19px" },
    lineHeight: { xs: "26px", md: "30px" },
    height: { xs: "119px", md: "106px" },
    mt: { xs: "17px", md: "24px", lg: "34px", xl: "44px" },
  },
  firstChild: {
    display: "flex",
    alignItems: { xs: "center", md: "flex-start" },
    flexDirection: { xs: "column" },
  },
  imageBox: {
    mt: { md: "50px", xl: "60px" },
  },
  child: {
    display: "flex",
    width: { md: "650px", lg: "800px", xl: "1050px" },
    justifyContent: { md: "space-between" },
  },
});

const MainTitle = ({ title, subtitle, img, width, mobileHeight, scroll }) => {
  const theme = useTheme();
  const classes = useStyles(theme, width, mobileHeight);

  const sm = useMediaQuery(
    json2mq({
      maxWidth: 1000,
      minWidth: 900,
    })
  );

  const md = useMediaQuery(
    json2mq({
      maxWidth: 1199,
      minWidth: 1000,
    })
  );

  const lg = useMediaQuery(
    json2mq({
      maxWidth: 1535,
      minWidth: 1200,
    })
  );
  const xl = useMediaQuery(
    json2mq({
      minWidth: 1536,
      maxWidth: 1700,
    })
  );

  const xxl = useMediaQuery(
    json2mq({
      minWidth: 1701,
    })
  );

  const stylesHelper = () => {
    if (xl || xxl) {
      return {
        mainImage: { width: "406px", height: "423px" },
      };
    } else if (sm)
      return {
        mainImage: { width: "325px", height: "350px" },
      };
    else if (md) {
      return {
        mainImage: { width: "300px", height: "300px" },
      };
    } else if (lg) {
      return {
        mainImage: { width: "325px", height: "350px" },
      };
    }
  };

  const isMobile = useMediaQuery("(max-width:899px)");

  const focusElement = useRef(null);

  const focusOnElement = () => {
    focusElement.current && focusElement.current.scrollIntoView();
  };

  useEffect(() => {
    if (focusElement && scroll) {
      focusOnElement();
    }
  }, [scroll]);

  return (
    <Box sx={classes.box} >
      <Box sx={classes.child}>
        <Box sx={classes.firstChild} >
          <Typography sx={classes.title}>{title}</Typography>
          <Typography sx={classes.subtitle} ref={focusElement}>{subtitle}</Typography>
        </Box>

        {!isMobile && (
          <Box sx={classes.imageBox} >
            <img
              src={img}
              alt="main logo"
              style={stylesHelper() && stylesHelper().mainImage}
            />
          </Box>
        )}
      </Box >
    </Box>
  );
};

export default MainTitle;
